
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { PartFilter } from "@/data/parts";

interface RequirementsSectionProps {
  requirements: PartFilter[];
  onRequirementsChange: (requirements: PartFilter[]) => void;
  hasCrealityK1K2: boolean;
}

const RequirementsSection: React.FC<RequirementsSectionProps> = ({
  requirements,
  onRequirementsChange,
  hasCrealityK1K2
}) => {
  const toggleRequirement = (filter: PartFilter) => {
    const isActive = requirements.includes(filter);
    if (isActive) {
      onRequirementsChange(requirements.filter(req => req !== filter));
    } else {
      onRequirementsChange([...requirements, filter]);
    }
  };

  const requirementItems = [
    {
      filter: "requires-root" as PartFilter,
      label: "Root",
      show: hasCrealityK1K2
    },
    {
      filter: "requires-tools" as PartFilter,
      label: "Tools",
      show: true
    },
    {
      filter: "wiring" as PartFilter,
      label: "Wiring",
      show: true
    },
    {
      filter: "requires-printing" as PartFilter,
      label: "Print",
      show: true
    },
    {
      filter: "requires-purchase" as PartFilter,
      label: "Purchase",
      show: true
    }
  ];

  const visibleRequirements = requirementItems.filter(item => item.show);

  if (visibleRequirements.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col lg:flex-row lg:gap-4">
      <Label className="lg:w-32 lg:flex-shrink-0 text-sm font-medium">
        Requirements
      </Label>
      <div className="lg:flex-1">
        <div className="flex flex-wrap gap-4">
          {visibleRequirements.map(({ filter, label }) => {
            const isActive = requirements.includes(filter);
            
            return (
              <div key={filter} className="flex items-center space-x-2">
                <Checkbox
                  id={filter}
                  checked={isActive}
                  onCheckedChange={() => toggleRequirement(filter)}
                />
                <Label
                  htmlFor={filter}
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  {label}
                </Label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RequirementsSection;
